import { render, staticRenderFns } from "./uppy_dashboard.vue?vue&type=template&id=31335d5a&scoped=true&"
import script from "./uppy_dashboard.vue?vue&type=script&lang=js&"
export * from "./uppy_dashboard.vue?vue&type=script&lang=js&"
import style0 from "./uppy_dashboard.vue?vue&type=style&index=0&id=31335d5a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31335d5a",
  null
  
)

export default component.exports